// extracted by mini-css-extract-plugin
export default {"modal":"FeedbackConfirmation_modal__iJZla","pictogram":"FeedbackConfirmation_pictogram__X-ExU"};